import {generateRandomNumberFunc} from './generateRandomNumberUtil';

const generateRandomNumber = (value: string[]) => {
  let newValue = generateRandomNumberFunc();
  while (value.includes(newValue.toString())) {
    newValue = generateRandomNumberFunc();
  }
  return newValue;
};

export default generateRandomNumber;
